import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { distribuidorModulo } from '../../diccionarios/distribuidorModulo';
import { DistribuidorMantenedorModel } from '../../models/distribuidorMantenedorModel';
import { RutaModel, RutaModelInterface } from '../../models/rutaModel';
import { CatalogoService } from '../../services/catalogo.service';
import { DistribuidorService } from '../../services/distribuidor.service';

@Component({
  selector: 'app-upload-csv-ruta',
  templateUrl: './upload-csv-ruta.component.html',
  styleUrls: ['./upload-csv-ruta.component.css']
})
export class UploadCsvRutaComponent implements OnInit {

  titulo = 'RUTA';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: RutaModel[] = [];

  textoBuscarCli = '';
  gridApiCli: any;
  gridColumnApiCli: any;
  columnDefsCli: any[];
  frameworkComponentsCli: any;
  rowSelectionCli: any;
  rowDataCli: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  distribuidorModulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGridRuta: RutaModelInterface;
  csv: string;

  dataRuta: RutaModel = {
    codigoClienteDistribuidor: '',// string;
    codigoClienteFabril: '',// string;
    diaVisita: '',// string;
    frecuenciaVisita: '',// string;
    secuenciaVisita: '',// string;
    semanaVisita: '',// string;
    correct: false,
    devolverModeloGridRuta() {
      return null
    }
  };
  objSelected: any = {};
  cmbDistribuidor: DistribuidorMantenedorModel[] = [];
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  // img = "https://img.konami.com/kde_cms/eu_publish/uploads/lost_art_cards_es-600x322.png"
  constructor(public fb: FormBuilder,
    private _util: UtilsService,
    private _distribuidor: DistribuidorService,
    private catalogo: CatalogoService,
  ) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      idDistribuidor: ['', [Validators.required]],
      multipart: ['', [Validators.required]],
    });
    const innClase = new RutaModel();
    this.modelGridRuta = innClase.devolverModeloGridRuta();
    // console.log(this.modelGridRuta);
    this.distribuidorModulo = distribuidorModulo;
    this.DAT_BTNS = this.distribuidorModulo.button.buttonsNombre;
    this.DAT_MSG = this.distribuidorModulo.mensajes;
    this.DAT_BTNCSS = this.distribuidorModulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.cargarGridCli();
    this.getDistribuidor();
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link'//'btn btn-danger btn btn-block'
        }
      },
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function(params: any){
          return (params.data.correct === true)?'CORRECTO':'INCORRECTO';
        }
      },
      {
        headerName: 'DISTRIBUIDOR',
        field: this.modelGridRuta.codigoClienteDistribuidor,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'CLIENTE',
        field: this.modelGridRuta.codigoClienteFabril,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'DIA VISITA',
        field: this.modelGridRuta.diaVisita,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'FRECUENCIA VISITA',
        field: this.modelGridRuta.frecuenciaVisita,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'SECUENCIA VISITA PAR',
        field: 'secuenciaVisitaPar',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'SECUENCIA VISITA IMPAR',
        field: 'secuenciaVisitaImpar',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DET.ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        sortable: true,
        filter: true,
        width: 450
      }
    ];
    this.rowSelection = 'multiple';
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return null;
  }

  cargarGridCli() {
    this.frameworkComponentsCli = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsCli = [
      {
        headerName: 'DISTRIBUIDOR',
        field: this.modelGridRuta.codigoClienteDistribuidor,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'CLIENTE',
        field: this.modelGridRuta.codigoClienteFabril,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'DIA VISITA',
        field: this.modelGridRuta.diaVisita,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'FRECUENCIA VISITA',
        field: this.modelGridRuta.frecuenciaVisita,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'SECUENCIA VISITA',
        field: this.modelGridRuta.secuenciaVisita,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'SEMANA VISITA',
        field: this.modelGridRuta.semanaVisita,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link'//'btn btn-danger btn btn-block'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarElemento.bind(this),
          label: 'Eliminar',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link'//'btn btn-danger btn btn-block'
        }
      },
    ];
    this.rowSelectionCli = 'multiple';
  }

  callModal({ rowData }) {
    this.dataRuta = rowData;
    document.getElementById('abrirModal').click();
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  eliminarElemento({ rowData }) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea Eliminar la siguiente Ruta?',
        text: '',
        action: 'Eliminar',
        funcion: this._distribuidor.deleteRuta(rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  // changeRowColor(params) {
  //   let data = params.data;
  //   if (data.estado != undefined) {
  //     if (data.estado === true) {
  //       return {
  //         'background-color': 'lightgreen',
  //         'color': 'black',
  //         'font-weight': 'bold',
  //         'font-size': '14px'
  //       };
  //     } else {
  //       return {
  //         'background-color': '#FFC0CB',
  //         'color': 'black',
  //         'font-weight': 'bold',
  //         'font-size': '14px'
  //       };
  //     }
  //   }
  // }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReadyCli(params) {
    this.gridApiCli = params.api;
    this.gridColumnApiCli = params.columnApi;
  }

  onQuickFilterChangedCli() {
    this.gridApiCli.setQuickFilter(this.textoBuscarCli);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._distribuidor.postUploadFileRuta(this.setFormData(this.formulario.value), this.formulario.get('idDistribuidor').value),
        loading: true,
        context: this,
      }
    ).then((res: RutaModel[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach (e =>{
      if(!e.correct){
         this.errorData = false; 
      }
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de rutas?',
        text: '',
        action: 'Guardar',
        funcion: this._distribuidor.postSaveFileRuta(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje, true, 3000);
    });
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.rowDataCli = [];
    this.listaVaciaCli = true;
    this.formulario.reset();
  }

  obtenerObjetoDistribuidor(event) {
    this.objSelected = event[0];
    if(this.objSelected != undefined) {
      this.formulario.get('idDistribuidor').setValue(this.objSelected.idDistribuidor);
      this.getAllPresupuesto(this.objSelected.idDistribuidor);
    } else {
      this.formulario.get('idDistribuidor').setValue('');
      this.rowDataCli = [];
      this.listaVaciaCli = true;
    }
  }

  getAllPresupuesto(idDistribuidor: string) { 
    this._distribuidor.getAllRuta(idDistribuidor).subscribe((res: RutaModel[])=>{
      this.rowDataCli = res;
      this.listaVaciaCli = this.rowDataCli.length === 0 ? true : false;
    },(err:any)=>{
      this.rowDataCli = [];
      this.listaVaciaCli = true;
      this._util.mensajeErroToast(err.error.mensaje);
    });
  }
  
  getDistribuidor() {
    this._distribuidor.getDistribuidor().subscribe((res: DistribuidorMantenedorModel[]) => {
      this.cmbDistribuidor = res;
      this.cmbDistribuidor = this.cmbDistribuidor.map((e) => {
        e.descripcion = e.idDistribuidor + ' ' + e.nombreDistribuidor;
        return e;
      });
    }, (err: any) => {
      this.cmbDistribuidor = [];
      console.log(err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }
  

}
